import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/email-templates/profile/loading';

export const Route = createFileRoute('/_private/settings/email-templates/$id')({
  pendingComponent: Loading,
});
